<template>
  <div class="text-xs-center">
    <v-dialog :value="value" @input="$emit('input')" :width="computedWidth">
      <v-card>
        <v-card-title class="headline grey lighten-2 py-0 title-mobile" primary-title>
          {{ computedTitle }}
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <v-btn flat fab small icon @click="$emit('input')" slot="activator">
              <v-icon>close</v-icon>
            </v-btn>
            <span>Cancelar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn
              color="primary"
              fab
              dark
              small
              @click="adiciona"
              :loading="loading"
              slot="activator"
            >
              <v-icon>done</v-icon>
            </v-btn>
            <span>Salvar</span>
          </v-tooltip>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="tipoAtividade.Descricao"
                  label="Descrição"
                  prepend-icon="description"
                  id="tipoatividade-add-item"
                  @keyup.enter="adiciona"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete 
                  v-model="tipoAtividadeWorkflow.Workflow"
                  :items="workflowsAtivo"
                  item-text="Descricao"
                  return-object
                  id="tipoatworkflow-add-item"
                  menu-props="auto"
                  label="Adicionar Workflow"
                  no-data-text="Registro não encontrado."
                  prepend-icon="label"
                  auto-select-first
                  @change="changeWorkflow"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-card>
                  <v-toolbar dense dark color="primary">
                    <v-toolbar-title>Workflows</v-toolbar-title>
                  </v-toolbar>
                  <v-card-text class="pa-0">
                    <!-- Lista Workflows -->
                    <v-flex xs12>
                      <v-list v-if="computedWorkflows.length">
                        <template v-for="(workflow, index) in computedWorkflows">
                          <v-list-tile :key="workflow.IdWorkflow">
                            <v-list-tile-content>
                              <v-list-tile-title>{{ workflow.Workflow }}</v-list-tile-title>
                            </v-list-tile-content>

                            <v-list-tile-action>
                              <div class="d-flex justify-end">
                                <v-tooltip bottom>
                                  <v-btn
                                    icon
                                    flat
                                    small
                                    class="mx-0"
                                    slot="activator"
                                    @click="excluiWorkflow(workflow)"
                                  >
                                    <v-icon small>delete</v-icon>
                                  </v-btn>
                                  <span>Excluir</span>
                                </v-tooltip>
                              </div>
                            </v-list-tile-action>
                          </v-list-tile>
                          <v-divider
                            v-if="index !== computedWorkflows.length - 1"
                            :key="index + workflow.Workflow"
                            class="mx-2"
                          ></v-divider>
                        </template>
                      </v-list>
                      <div v-else class="d-flex my-3">
                        <span class="text-xs-center font-weight-bold">Nenhum workflow adicionado à esse tipo atividade.</span>
                      </div>
                    </v-flex>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import TipoAtividade from '@/domain/tipoAtividade/TipoAtividade';
import TipoAtividadeWorkflow from '@/domain/tipoAtividade/TipoAtividadeWorkflow';

export default {
  name: 'ModalCadastroTipoAtividade',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    tipoAtividade: {
      type: Object,
      default: () => new TipoAtividade()
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      tipoAtividadeWorkflow: new TipoAtividadeWorkflow(),
      workflowsAdicionar: []
    }
  },
  watch: {
    value(newValue) {
      if (newValue && !this.workflowsAtivo.length) this.fetchWorkflows();
      this.$nextTick(() => document.getElementById('tipoatividade-add-item').focus());
    }
  },
  computed: {
    ...mapGetters(['tipoAtividadeWorkflows', 'workflowsAtivo']),
    computedTitle() {
      return this.tipoAtividade.IdTipoAtividade ? 'Editar Tipo Atividade' : 'Nova Tipo Atividade';
    },
    computedWidth() {
      return this.$vuetify.breakpoint.smAndDown ? '100%' : '60%';
    },
    computedWorkflows() {
      if (this.tipoAtividadeWorkflows.length) return this.tipoAtividadeWorkflows;
      if (this.workflowsAdicionar.length) return this.workflowsAdicionar;
      return [];
    },
  },
  methods: {
    ...mapActions([
      'fetchWorkflows',
      'addTipoAtividade',
      'addTipoAtividadeWorkflow',
      'updateTipoAtividade',
      'deleteTipoAtividadeWorkflow'
    ]),
    ...mapMutations(['showNotification', 'closeNotification']),
    async changeWorkflow(obj) {
      this.tipoAtividadeWorkflow.IdWorkflow = obj.IdWorkflow;
      this.tipoAtividadeWorkflow.Workflow = obj.Descricao;
      const newTipoAtividadeWorkflow = Object.assign({}, this.tipoAtividadeWorkflow);

      if (this.tipoAtividade.IdTipoAtividade) {
        newTipoAtividadeWorkflow.IdTipoAtividade = this.tipoAtividade.IdTipoAtividade;
        try {
          this.loading = true;
          const tipoAtividadeAdicionado = await this.addTipoAtividadeWorkflow(newTipoAtividadeWorkflow);
          if (tipoAtividadeAdicionado && tipoAtividadeAdicionado.data.IdWorkflow) {
            this.showNotification({ text: `Workflow ${obj.Descricao} adicionado ao tipo atividade.`, status: 'success' });
            this.tipoAtividadeWorkflow = Object.assign({}, new TipoAtividadeWorkflow());
          }
          this.$emit('workflowAdicionado');
          this.$nextTick(() => document.getElementById('tipoatworkflow-add-item').focus());
          this.loading = false;
        } catch (error) {
          this.loading = false;
          this.showNotification({ text: `Ocorreu um erro ao adicionar o workflow: ${error}.`, status: 'error' });
        }
      } else {
        this.workflowsAdicionar.push(newTipoAtividadeWorkflow);
        this.tipoAtividadeWorkflow = new TipoAtividadeWorkflow();
        this.$nextTick(() => document.getElementById('tipoatworkflow-add-item').focus());
      }
    },
    async adicionaWorkflowsPendentes(idTipoAtividade) {
      if (this.workflowsAdicionar.length) {
        for (const workflow of this.workflowsAdicionar) {
          workflow.IdTipoAtividade = idTipoAtividade;
          await this.addTipoAtividadeWorkflow(workflow);
        }
        this.workflowsAdicionar = [];
      } else {
        return;
      }
    },
    async excluiWorkflow(workflow) {
      if (workflow.IdTipoAtividade && confirm(`Desejar remover o workflow: ${workflow.Workflow}?`)) {
        this.loading = true;
        try {
          await this.deleteTipoAtividadeWorkflow(workflow);
          this.loading = false;
          this.showNotification({ text: 'Workflow removido com sucesso.', status: 'success' });
        } catch (error) {
          this.loading = false;
          console.log(error);
          this.showNotification({ text: `Ocorreu um erro ao remover o workflow: ${error}`, status: 'error' });
        }
      } else {
        this.showNotification({ text: `Operação cancelada.`, status: 'error' });
      }
    },
    async adiciona() {
      if (!this.tipoAtividade.IdTipoAtividade && this.tipoAtividade.Descricao) {
        this.loading = true;
        const newTipoAtividade = Object.assign({}, this.tipoAtividade);
        try {
          const id = await this.addTipoAtividade(newTipoAtividade);
          await this.adicionaWorkflowsPendentes(id);
          this.showNotification({ text: `Tipo Atividade: ${newTipoAtividade.Descricao} adicionado com sucesso.`, status: 'success' });
          this.loading = false;
          this.$emit('input');
          this.$emit('tipoAtividadeAdicionado');
        } catch (error) {
          this.showNotification({ text: `Ocorreu um erro ao adicionar o tipo atividade: ${error}.`, status: 'error' });
        }
      } else if (this.tipoAtividade.IdTipoAtividade && this.tipoAtividade.Descricao) {
        this.loading = true;
        const updTipoAtividade = Object.assign({}, this.tipoAtividade);
        try {
          await this.updateTipoAtividade(updTipoAtividade);
          this.showNotification({ text: `Tipo Atividade: ${updTipoAtividade.Descricao} atualizado com sucesso.`, status: 'success' });
          this.loading = false;
          this.$emit('input');
          this.$emit('tipoAtividadeAdicionado');
        } catch (error) {
          this.showNotification({ text: `Ocorreu um erro ao atualizar o tipo atividade: ${error}.`, status: 'error' });
        }
      } else {
        this.loading = false;
        this.showNotification({ text: `Informe a Descrição do tipo atividade.`, status: 'error' });
      }
    }
  },
}
</script>

<style scoped>
@media screen and (max-width: 480px) {
  .title-mobile {
    font-size: 1.125rem !important;
  }
}
.cursor-pointer {
  cursor: pointer;
}
</style>
